// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__2uA5a","sectionsWrapper":"style_sectionsWrapper__1s2GF","tableWrapper":"style_tableWrapper__3xXM_","tableTitle":"style_tableTitle__v17T4"};